import React, { Component } from 'react';
import SEO from '../components/SEO';
import Cheatsheet from '../components/cheatsheets/';
import Layout from '../layout';

class Page extends Component {
  render() {
    return (
      <Layout>
        <SEO
          title="Cheatsheets"
          keywords={['']}
          pathname={this.props.location.pathname}
          description="A collection of handy sheets for web devs, covering CSS Flexbox, CSS Grid, Anchor Positioning, and Invoker Commands."
          ogFileName="cheatsheets"
        />
        <Cheatsheet />
      </Layout>
    );
  }
}

export default Page;
